import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
    'https://sehmaceyalfmmdbuzpwy.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNlaG1hY2V5YWxmbW1kYnV6cHd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODU0MzcxNTAsImV4cCI6MjAwMTAxMzE1MH0.i9P3-viFjZmPF37oJuHOAIOxveZSEDb7hrPG08mED7w'
)